import React, { FC } from 'react'

interface Props {
  size?: number
  className?: string
}

export const YouTubeIcon: FC<Props> = ({ size = 25, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 25 22"
    fill="none"
    className={className}
  >
    <path
      d="M12.2153 4.07397C12.2153 4.07397 5.21208 4.07399 3.45437 4.53072C2.51322 4.79368 1.73827 5.56865 1.47529 6.52364C1.01856 8.28135 1.01855 11.9214 1.01855 11.9214C1.01855 11.9214 1.01856 15.5754 1.47529 17.3054C1.73827 18.2604 2.49938 19.0214 3.45437 19.2845C5.22593 19.755 12.2153 19.755 12.2153 19.755C12.2153 19.755 19.2324 19.755 20.9901 19.2983C21.9451 19.0354 22.7062 18.2881 22.9553 17.3193C23.4259 15.5754 23.4259 11.9353 23.4259 11.9353C23.4259 11.9353 23.4398 8.28135 22.9553 6.52364C22.7062 5.56865 21.9451 4.80754 20.9901 4.55841C19.2324 4.074 12.2153 4.07397 12.2153 4.07397ZM9.987 8.55831L15.8139 11.9214L9.987 15.2707V8.55831Z"
      fill="white"
    />
  </svg>
)
